/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import router from "../router";
import teacher from "./modules/teacher";

import { mappings } from "@/helpers/mappingsHelper";
import { currentFiscalYear } from "@/helpers/currentYear";
import { apiBase, schools } from "@/helpers/storeHelper";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    teacher,
    admin: {
      namespaced: true,
      state: {
        schools: [],
        selectedSchool: {
          name: null,
          dbn: null,
          teachers: [],
          evaluators: [],
          gradeLevels: [],
          subjects: []
        },
        districts: {
          selected: [],
          list: [],
          schools: []
        },
        schoolStaff: []
      },
      mutations: {
        updateSchools(state, schools) {
          state.schools = schools;
        },
        updateDistrictSchools(state, schools) {
          state.districts.schools = schools
        },
        updateSelectedSchool(state, selectedSchool) {
          state.selectedSchool = Object.assign(state.selectedSchool, selectedSchool)
        },
        updateTeachers(state, teachers) {
          state.selectedSchool.teachers = teachers;
        },
        updateEvaluators(state, evaluators) {
          state.selectedSchool.evaluators = evaluators;
        },
        updateGradeLevels(state, grades) {
          state.selectedSchool.gradeLevels = grades;
        },
        updateSubjects(state, subjects) {
          state.selectedSchool.subjects = subjects;
        },
        updateStaff (state, staff) {
          state.schoolStaff = staff
        },
        updateSelectedDistricts (state, districts) {
          state.districts.selected = districts
        },
        updateDistrictsList (state, districts) {
          state.districts.list = districts
        }
      },
      actions: {
        updateFiltersValues({ commit, state }, year) {
          const _teachers = state.selectedSchool.teachers.filter(
            t => t.FiscalYear === year
          );

          let grades = [];
          let subjects = [];

          const _grades = _teachers.map(t => t.GRADE_LEVEL_DESC).filter(g => g);
          const _subjects = _teachers.map(t => t.SUBJECT_DESC).filter(s => s);

          _grades.forEach(element => {
            const arr = element.split("|");

            if (arr.length > 1) {
              for (let i = 0; i < arr.length; i++) {
                grades.push(arr[i]);
              }
            } else {
              grades.push(arr[0]);
            }
          });

          _subjects.forEach(element => {
            const arr = element.split("|");

            if (arr.length > 1) {
              for (let i = 0; i < arr.length; i++) {
                subjects.push(arr[i]);
              }
            } else {
              subjects.push(arr[0]);
            }
          });

          grades = [...new Set(grades)];

          subjects = [...new Set(subjects)];

          const splitEvaluators = _teachers
            .filter(t => t.EvaluatorName)
            .map(t => t.EvaluatorName.split("|"));

          const mergedEvaluators = [].concat.apply([], splitEvaluators);

          const evaluators = [...new Set(mergedEvaluators)];

          commit("updateEvaluators", evaluators);
          commit("updateGradeLevels", grades);
          commit("updateSubjects", subjects);
        },
        async fetchSchools({ commit, rootState }) {
          try {
            const { data: Schools } = await axios.get(
              `${apiBase}/data/admin/app/ge/info/schools/${rootState.employeeId}`
            )
                        
            const _schools = Schools.map(school => {
              school.name = school.SchoolDBN_Name || school.LocationName
              school.dbn = school.SchoolDBN
              school.display_name = `${school.dbn}: ${school.name}`

              school.teachers = []
              school.evaluators = []
              school.gradeLevels = []
              school.subjects = []
              return school
            })

            // need to think about restructuring admin state in store
            commit("updateDistrictSchools", _schools)
            commit("updateSchools", _schools)

            let s = _schools.filter(x => schools.includes(x.dbn));
            const { data: staff } = await axios.get(
              `${apiBase}/data/school/staff/${s[0].dbn}`
            );
            const index = schools.indexOf(s[0].dbn);

            if (
              index !== -1 &&
              (rootState.role === "Teacher" || rootState.role === "Principal")
            ) {
              commit("journalAccess", true, { root: true });
            }

            commit("updateStaff", staff);
          } catch (e) {
            console.log(e);
          }
        },

        async fetchSelectedSchool({ commit, rootState }, value) {  
          try {
            const p1 = axios.get(
              `${apiBase}/data/school/motp/school/${value.dbn}`
            )
            const p2 = axios.get(`${apiBase}/data/school/motp/teacher/${value.dbn}`)
            const p3 = axios.get(`${apiBase}/data/school/motp/observations/${value.dbn}`)
            
            const [schoolMotpData, teacherList, observationsList] = await Promise.all([p1, p2, p3])

            value.motp_data = schoolMotpData.data
            value.teachers = teacherList.data
            value.observations = observationsList.data

            commit("updateSelectedSchool", value)
            
            //why is this here? Same endpoint is being called above
            const t = await axios.get(`${apiBase}/data/school/motp/teacher/${value.dbn}`)
          
            const _teachers = t.data.filter(t => t.FiscalYear === rootState.fiscalYear)
            
            let grades = []
            let subjects = []

            const _grades = _teachers.map(t => t.GRADE_LEVEL_DESC).filter(g => g)
            const _subjects = _teachers.map(t => t.SUBJECT_DESC).filter(s => s)

            _grades.forEach(element => {
              const arr = element.split("|");

              if (arr.length > 1) {
                for (let i = 0; i < arr.length; i++) {
                  grades.push(arr[i]);
                }
              } else {
                grades.push(arr[0]);
              }
            });

            _subjects.forEach(element => {
              const arr = element.split("|");

              if (arr.length > 1) {
                for (let i = 0; i < arr.length; i++) {
                  subjects.push(arr[i]);
                }
              } else {
                subjects.push(arr[0]);
              }
            });

            grades = [...new Set(grades)];

            subjects = [...new Set(subjects)];

            const splitEvaluators = _teachers
              .filter(t => t.EvaluatorName)
              .map(t => t.EvaluatorName.split("|"));

            const mergedEvaluators = [].concat.apply([], splitEvaluators);

            const evaluators = [...new Set(mergedEvaluators)]

            commit('updateEvaluators', evaluators)
            commit('updateGradeLevels', grades)
            commit('updateSubjects', subjects)
            
          } catch(e) {
            console.log(e)
          }
        },

        fetchTeacherComments({ commit }, teacher) {
          const _teacher = teacher;

          return new Promise((resolve, reject) => {
            const components = axios.get(
              `${apiBase}/data/teacher/component/${_teacher.EmployeeID}`
            );
            const observations = axios.get(
              `${apiBase}/data/teacher/observations/${_teacher.EmployeeID}`
            );

            Promise.all([components, observations]).then(data => {
              const [_components, _observations] = data;

              var r = /mean/;

              for (let prop in _teacher) {
                if (r.test(prop)) {
                  let key = prop.split("_")[0].slice(-2);

                  const y = mappings[key];

                  let arr = [];

                  if (typeof y === "object") {
                    for (let i = 0; i < y.length; i++) {
                      let a = _components.data.filter(
                        f => f.MOTPComponentID == y[i]
                      );
                      arr.length > 0 ? (arr = arr.concat(a)) : (arr = a);
                    }
                  } else {
                    arr = _components.data.filter(
                      f => f.MOTPComponentID == y && f.Rating
                    );
                  }

                  const mapComments = arr.map(m => {
                    const {
                      MOTPDate,
                      TimePeriod,
                      EvaluatorName,
                      Comments
                    } = _observations.data.find(o => o.MOTPID === m.MOTPID);

                    m.Comments = Comments;
                    m.Date = MOTPDate;
                    m.Class = TimePeriod;
                    m.Observer = EvaluatorName;
                    return m;
                  });

                  for (let prop in _teacher.components) {
                    if (prop === key) {
                      _teacher.components[key].comments = mapComments;
                    }
                  }
                }
              }

              resolve(_teacher)

            })
          })
        }
      }, 
      getters: {
        getSchools(state) {
          return state.districts.list.length > 0 ? state.districts.schools : state.schools
        },
        getSelectedSchool(state) {
          return state.selectedSchool;
        },
        getDistricts(state) {
          return state.districts
        },
        getTeachers (state) {
          return state.selectedSchool.teachers.map(t => {
            t.grades = t.GRADE_LEVEL_DESC ? t.GRADE_LEVEL_DESC.split("|") : [];
            t.subjects = t.SUBJECT_DESC ? t.SUBJECT_DESC.split("|") : [];
            t.evaluators = t.EvaluatorName ? t.EvaluatorName.split("|") : [];
            return t;
          });
        },
        getEvaluators(state) {
          return state.selectedSchool.evaluators.map(e => {
            return { name: e };
          });
        },
        getGradeLevels(state) {
          return state.selectedSchool.gradeLevels.map(g => {
            return { name: g };
          });
        },
        getSubjects(state) {
          return state.selectedSchool.subjects.map(s => {
            return { name: s };
          });
        },
        getSchoolStaff(state) {
          return state.schoolStaff.sort((a, b) => {
            if (a.LastName < b.LastName) {
              return -1;
            }
            if (a.LastName > b.LastName) {
              return 1;
            }
            return 0;
          });
        }
      }
    }
  },

  state: {
    journalAccess: false,
    role: "",
    employeeId: "",
    userName: "",
    firstName: "",
    lastName: "",
    dbn: "",
    fiscalYear: currentFiscalYear(new Date()),
    currentPage: 'home'
  },

  mutations: {
    updateUser(state, data) {
      state.role = data.role;
      state.employeeId = data.employee_id;
      state.userName = data.user_id;
      state.firstName = data.first_name;
      state.lastName = data.last_name;
      state.dbn = data.dbn;
    },
    updateFiscalYear(state, fiscalYear) {
      state.fiscalYear = fiscalYear;
    },
    journalAccess(state, access) {
      state.journalAccess = access
    },
    currentPage(state, page) {
      state.currentPage = page
    }
  },

  actions: {
    async userInit({ commit }) {
      try {
        const { data: user } = await axios.get(`${apiBase}/app/ge`)

        commit("updateUser", user)

        return user

      } catch (e) {
        console.log(e);
      }
    }
  },

  getters: {
    getCurrentPage(state) {
      return state.currentPage
    },
    getUserRole(state) {
      return state.role;
    },
    getEmployeeId(state) {
      return state.employeeId;
    },
    getUserName(state) {
      return state.userName;
    },
    getFirstName(state) {
      return state.firstName;
    },
    getLastName(state) {
      return state.lastName;
    },
    getFiscalYear(state) {
      return state.fiscalYear;
    },
    getDBN(state) {
      return state.dbn;
    },
    getJournalAccess(state) {
      return state.journalAccess;
    }
  }
});
